import r from '../utils/request'
import { API_ROOT } from '../utils/constants'

// Recipe request links: the member's links and review list, and the relative's page

export const getRequestLinks = () => r.get('/recipe-requests/links')

export const createRequestLink = (params) => r.post('/recipe-requests/links', params)

export const revokeRequestLink = (id) => r.delete(`/recipe-requests/links/${id}`)

export const getSubmissions = (status = 'pending') =>
  r.get('/recipe-requests/submissions', { status })

export const approveSubmission = (id) => r.post(`/recipe-requests/submissions/${id}/approve`)

export const declineSubmission = (id) => r.post(`/recipe-requests/submissions/${id}/decline`)

// A photo's signed link, relative to the API root
export const submissionPhotoUrl = (link) => (link ? `${API_ROOT}${link}` : '')

export const getShareLink = (token) => r.get(`/share-recipe/${token}`)

export const sendRecipe = (token, formData) => r.post(`/share-recipe/${token}`, formData)
